import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import flyerPrintTemplateStrings from './contextualStrings';
import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl, isAlbumFolderParentPay } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplatePFNoJoinCode = ({ albumFolder, account }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);
  const url = `https://waldophotos.com/@${account.username}`;
  // photoFinderMainCopy here acts like a catch all where if all templates fail this will print.
  const stringId = isAlbumFolderParentPay(albumFolder)
    ? 'parentPayMainCopy'
    : 'photoFinderMainCopy';

  return (
    <Fragment>
      <p className="marketing-material-flyer-main-copy">
        <strong>{account.organization_name}</strong>{' '}
        <ContextualString
          id={stringId}
          defaultMessage="is excited to announce we’re offering Waldo’s facial recognition powered mobile app to deliver photos to you! You’ll be able to sit back and relax while Waldo delivers YOUR photos to you and your family members for FREE!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={flyerPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>

      <p className="marketing-material-flyer-target-enroll-copy">
        Visit our profile page at:
        <br />
        <span>{url}</span>
      </p>

      <div
        className="marketing-material-flyer-qrcode-secondary wg-flyer-qrcode"
        style={{
          top: '56%',
          right: `calc(50% - ${Math.round((width * 0.27 ?? 500) / 2)}px)`,
        }}
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.27 ?? 500}
        />
      </div>
      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_GENERAL_1_PROFILE.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplatePFNoJoinCode.propTypes = propTypes;

export default FlyerPrintTemplatePFNoJoinCode;
